// A deliberately tiny, safe markdown renderer shared by the Terms of Use page
// and the staff review page: headings, paragraphs, "-" lists and **bold**.
// Everything else is escaped, so the text can never inject HTML.

import { esc } from './ui';

/** Escape, then turn **x** into <strong>x</strong>. */
function inline(text: string) {
  return esc(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
}

/**
 * Safe markdown: "#".."###" headings, "- " or "* " list items, blank-line separated
 * paragraphs (single newlines join), **bold**. No links, images or raw HTML.
 * `headingOffset` shifts heading levels so the page's own title can stay the h1.
 */
export function renderMarkdown(md: string, headingOffset = 0): string {
  const out: string[] = [];
  let para: string[] = [];
  let list: string[] = [];
  const flushPara = () => { if (para.length) out.push(`<p>${inline(para.join(' '))}</p>`); para = []; };
  const flushList = () => { if (list.length) out.push(`<ul>${list.map((li) => `<li>${inline(li)}</li>`).join('')}</ul>`); list = []; };
  for (const raw of md.replace(/\r\n?/g, '\n').split('\n')) {
    const line = raw.trim();
    const h = /^(#{1,6})\s+(.*)$/.exec(line);
    const li = /^[-*]\s+(.*)$/.exec(line);
    if (!line) { flushPara(); flushList(); }
    else if (h) { flushPara(); flushList(); const n = Math.min(6, h[1].length + headingOffset); out.push(`<h${n}>${inline(h[2])}</h${n}>`); }
    else if (li) { flushPara(); list.push(li[1]); }
    else if (list.length) list[list.length - 1] += ` ${line}`;
    else para.push(line);
  }
  flushPara(); flushList();
  return out.join('');
}
